// Self-contained private-mode reason for the Home v2 chrome (Sidebar /
// BottomTabBar). Mirrors the base computation in useHomeDashboard but skips the
// transient engine-init mapping — the nav chrome only gates on the *permanent*
// blocks (see isPrivateModeBlocked), so the initializing/failed states are
// irrelevant here. Lets Sidebar/BottomTabBar gate the private entry points
// without threading privateModeReason through AppShell from every screen.
import { useMemo } from 'react'

import useKeystoreControllerState from '@web/hooks/useKeystoreControllerState'
import useRailgunContext from '@web/hooks/useRailgunContext'
import useSelectedAccountControllerState from '@web/hooks/useSelectedAccountControllerState'
import { computePrivateModeReason, PrivateModeReason } from '@web/utils/privateModeAvailability'

const usePrivateModeReason = (): PrivateModeReason => {
  const { account } = useSelectedAccountControllerState()
  const { allRailgunWallets } = useRailgunContext()
  const { keys, seeds } = useKeystoreControllerState()

  const hasRailgunWallet = useMemo(
    () => allRailgunWallets.some((w) => w.accountAddr === account?.addr),
    [allRailgunWallets, account?.addr]
  )

  return useMemo(
    () =>
      computePrivateModeReason({
        account,
        keys,
        seedIds: seeds?.map((s) => s.id),
        hasRailgunWallet
      }),
    [account, keys, seeds, hasRailgunWallet]
  )
}

export default usePrivateModeReason
